<div class="pension-source-container">
  @if (sourceConfig['enableFlag']) {
    <div class="col-md-5 col-sm-12 source-div"
  [ngClass]="{'margin-left-7':((sourceConfig['code']==='B') && sourceSelected 
  && (sourceSelected.value !== 'B' && sourceSelected.value !== 'R'))}"
      [formGroup]="parent">
      <div class="border-div">
        <div class="logo-div">
          <!-- <img [id]="'img-'+getID(sourceConfig['sourceName'])" *ngIf="sourceConfig['iconSrcUrl'] !== ''; else otherSource" [src]="sourceConfig['iconSrcUrl']"
          [alt]="sourceConfig['sourceName']">
          <ng-template #otherSource>
            <span class="other-source" id="{{sourceName}}">{{sourceConfig['sourceName']}}</span>
          </ng-template> -->
          <span class="other-source" id="{{sourceName}}">{{(length === 1 || isDealPartnerWithoutProductCode|| sourceSelected.value === 'R') ? contentData.pensionPotText : sourceConfig['sourceName']}}</span>
        </div>
        <app-currency class="currency-box" [parent]="parent" [controllerData]="fundConfig" (currencyChangeEventEmitter)="currencyChangeHandler($event)"
        (currenyChildEmitter)="currenyChangeChildHandler($event)"></app-currency>
        @if (sourceConfig['productCodeFlag'] && fundAmount > 0) {
          <div>
            <div class="separator"></div>
            <div class="infoPositioning">
              <label for="{{productCodeConfig['name']}}" class="form-label product-code" [id]="'lbl-'+productCodeConfig['label']">{{productCodeConfig['label']}}</label>
            </div>
            <div class="infotext">
              <app-tool-tip-notification (contractCodeEmitter)="contractCodeReceiver($event)"
                (GACodeEmitter)="GACodeReceiver($event)" [childId]="sourceConfig['sourceName']"
                [tooltipName]="" [tooltipData]="sourceConfig['infoIconData']"
                (displayMobileTooltipEmitter)="displayTooltipMessage()">
              </app-tool-tip-notification>
              @if (displayAlert) {
                <app-modal [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
                (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>
              }
            </div>
            <div class="code-input" [formArrayName]="'productCode'">
              @for (prdcode of parent.get('productCode').controls || []; track prdcode; let i = $index) {
                <div class="display-inline-flex">
                  <app-text-input  [controlName] ="i" [sourceData]="sourceConfig" [parent]="parent.get('productCode')" [controllerData]="productCodeConfig"
                  [pageName]="'yourPensionSavings'" (textChangeEventEmitter)="productCodeChangeHandler(code)"></app-text-input>
                  @if (parent.get('productCode').controls.length > 1) {
                    <span class="icon icon-plus delete-icon"  (click)="removeConractCode(i)"></span>
                  }
                </div>
              }
            </div>
            @if (sourceConfig['sourceName'] == 'ReAssure') {
              <button id="btn-addNewcontract" name="addNewContractCode" class="btn add-new-code"
                type="button" (click)="addInsertRecords()" [disabled]="parent.get('productCode').controls.length >= 10">{{productCodeConfig['addAnothercode']}}
                <i class="icon icon-plus fl-right" aria-hidden="true"></i>
              </button>
            }
            @if (minprodCodeLength.value) {
              <div id="productCodeError" class="col-xs-12 form-validation-error">
                <i class="icon icon-error" aria-hidden="true"></i>
                <p  id="noFund-error">{{productCodeConfig['errorProductCode']}}</p>
              </div>
            }
          </div>
        }
      </div>
      @if (parent.get('fundValue').touched
        &&
        parent.get('fundValue').errors && parent.get('fundValue').errors.emptyFund) {
        <div class="col-md-6 form-validation-error text-left">
          <i class="icon icon-error" aria-hidden="true"></i>
          <p [id]="'fundValue-error'">
            {{productCodeConfig.validationMsg}}
          </p>
        </div>
      }
    </div>
  }
</div>